import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FormControl from 'react-bootstrap/lib/FormControl';

import t from '../../../lib/I18n';

import Icon from '../../general/Icon';

const DEFAULT_STEP = 15;

export const minutes = minuteStep => _.range(0, 60, minuteStep);

export const roundMinutes = (value, step = DEFAULT_STEP) => Math.ceil(value / step) * step;

const changeHandler = (callback) => (e) => callback(parseInt(e.target.value, 10));

function MinuteSelector ({ minute, minuteStep, onChange, disabled, min, max }) {
    const uniqueId = _.uniqueId('minute__selector_');
    return (
        <div className="minutes select-container">
            <Icon icon="dropdown" />

            <label htmlFor={ uniqueId } className="sr-only">
                { t('booking.time.labels.minutes') }
            </label>

            <FormControl
                componentClass="select"
                disabled={ disabled }
                name="minutes"
                id={ uniqueId }
                className="minutes__form-control"
                value={ roundMinutes(minute, minuteStep) }
                onChange={ changeHandler(onChange) }
            >
                {minutes(minuteStep).map(num =>
                    <option
                        key={ num }
                        value={ num }
                        disabled={ num > max || num < min }
                    >
                        { _.padStart(num, 2, '0') }
                    </option>
                )}
            </FormControl>
        </div>
    );
}

MinuteSelector.propTypes = {
    minute: PropTypes.number,
    minuteStep: PropTypes.number,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    min: PropTypes.number,
    max: PropTypes.number
};

MinuteSelector.defaultProps = {
    minute: 0,
    minuteStep: DEFAULT_STEP,
    onChange: _.noop,
    disabled: false,
    min: 0,
    max: 59
};

export default MinuteSelector;
